import { EventType } from './events';

export interface ApplicationEvent<T extends EventType, P> {
  id: T;
  payload: P;
}

export interface ApplicationEventFactory<Type extends EventType, Payload> {
  (payload: Payload): ApplicationEvent<Type, Payload>;
  is(event: ApplicationEvent<any, any>): event is ApplicationEvent<Type, Payload>;
}

export function applicationEvent<T extends EventType, Payload = void>(
  type: T
): ApplicationEventFactory<T, Payload> {
  const factory = function (payload: Payload): ApplicationEvent<T, Payload> {
    return {
      id: type,
      payload,
    };
  };

  factory.is = function (event: ApplicationEvent<any, any>): event is ApplicationEvent<T, Payload> {
    return event.id === type;
  };

  return factory as ApplicationEventFactory<T, Payload>;
}
